/*
 * Kahvikoneet.fi - ALV 0 % -kytkin
 * Nayttaa hinnat joko arvonlisaverollisina (oletus) tai ilman arvonlisaveroa.
 * Vaikuttaa vain nayttoon: kassalla hinnat ovat aina arvonlisaverollisia.
 * Verokanta: tuotekortit ja tuotesivu data-kk-vat-attribuutista (Liquid),
 * ostoskori /cart.js:n tuotetyypeista, hakuehdotukset /products/<handle>.js:sta.
 */
(function () {
  'use strict';

  var KEY = 'kkAlvTila';
  var STD = 25.5;
  var RED = 13.5;
  var cfg = window.kkAlv || {};
  var FOOD = cfg.foodTypes || [];
  var root = document.documentElement;

  var RX = /(\d{1,3}(?:[.  ]\d{3})*,\d{2})([\s ]*)€/g;
  var RX1 = /\d,\d{2}[\s ]*€/;
  var PRICE_SEL = [
    '.grid-product__price',
    '.grid-product__price--original',
    '.grid-product__price--savings',
    '[data-product-price]',
    '[data-compare-price]',
    '[data-save-price]',
    '[data-unit-price]',
    '.product__unit-price',
    '.cart__price',
    '.cart__discount'
  ].join(',');

  var orig = new WeakMap();
  var shown = new WeakMap();
  var cartRates = {};
  var cartTried = {};
  var cartNet = null;
  var cartTotal = null;
  var cartLoading = false;
  var cartFetchedFor = null;
  var handleRates = loadHandleCache();
  var handleTried = {};

  function readMode() {
    try { return localStorage.getItem(KEY) === 'net' ? 'net' : 'gross'; }
    catch (e) { return root.classList.contains('kk-net') ? 'net' : 'gross'; }
  }
  var mode = readMode();

  function rateForType(t) { return FOOD.indexOf(t) > -1 ? RED : STD; }
  function rateText(r) { return String(r).replace('.', ','); }

  function cents(s) {
    return Math.round(parseFloat(s.replace(/[.  ]/g, '').replace(',', '.')) * 100);
  }
  function fmt(c) {
    var neg = c < 0;
    c = Math.abs(c);
    var e = Math.floor(c / 100);
    var d = c % 100;
    return (neg ? '-' : '') + String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + (d < 10 ? '0' : '') + d;
  }
  function toNetCents(c, r) { return Math.round(c * 100 / (100 + r)); }
  function toNetText(text, r) {
    return text.replace(RX, function (m, a, sp) {
      return fmt(toNetCents(cents(a), r)) + (sp || ' ') + '€';
    });
  }

  function handleOf(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function loadHandleCache() {
    try { return JSON.parse(sessionStorage.getItem('kkAlvHandles') || '{}'); } catch (e) { return {}; }
  }
  function saveHandleCache() {
    try { sessionStorage.setItem('kkAlvHandles', JSON.stringify(handleRates)); } catch (e) {}
  }
  function loadHandle(h) {
    if (handleTried[h]) return;
    handleTried[h] = true;
    fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { handleRates[h] = p ? rateForType(p.type) : STD; saveHandleCache(); })
      .catch(function () { handleRates[h] = STD; })
      .then(schedule);
  }

  function loadCart(forTotal) {
    if (cartLoading) return;
    cartLoading = true;
    cartFetchedFor = forTotal;
    var url = (window.theme && theme.routes && theme.routes.cart) || '/cart.js';
    fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var sumFinal = 0;
        var sumNet = 0;
        cartRates = {};
        (c.items || []).forEach(function (it) {
          var r = rateForType(it.product_type);
          cartRates[it.key] = r;
          sumFinal += it.final_line_price;
          sumNet += it.final_line_price * 100 / (100 + r);
        });
        var k = sumFinal > 0 ? c.total_price / sumFinal : 1;
        cartNet = Math.round(sumNet * k);
        cartTotal = c.total_price;
      })
      .catch(function () {})
      .then(function () { cartLoading = false; schedule(); });
  }

  // Palauttaa verokannan elementille, tai null jos tieto on viela latautumassa.
  function rateFor(el) {
    var c = el.closest('[data-kk-vat]');
    if (c) {
      var v = parseFloat(c.getAttribute('data-kk-vat'));
      if (!isNaN(v)) return v;
    }
    var item = el.closest('.cart__item[data-key]');
    if (item) {
      var key = item.getAttribute('data-key');
      if (cartRates[key] != null) return cartRates[key];
      if (!cartTried[key]) { cartTried[key] = true; loadCart(null); return null; }
      return cartLoading ? null : STD;
    }
    var a = el.closest('a[href*="/products/"]');
    if (a) {
      var h = handleOf(a.getAttribute('href'));
      if (h) {
        if (handleRates[h] != null) return handleRates[h];
        loadHandle(h);
        return null;
      }
    }
    return STD;
  }

  function textNodes(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var out = [];
    var n;
    while ((n = w.nextNode())) out.push(n);
    return out;
  }

  function processEl(el) {
    var r;
    var rateKnown = false;
    textNodes(el).forEach(function (t) {
      var cur = t.nodeValue;
      if (mode === 'net') {
        if (shown.get(t) === cur) return;
        if (!RX1.test(cur)) return;
        if (!rateKnown) { r = rateFor(el); rateKnown = true; }
        if (r == null) return;
        var v = toNetText(cur, r);
        orig.set(t, cur);
        shown.set(t, v);
        t.nodeValue = v;
      } else if (shown.has(t)) {
        if (shown.get(t) === cur) t.nodeValue = orig.get(t);
        shown.delete(t);
        orig.delete(t);
      }
    });
  }

  function processSubtotals() {
    document.querySelectorAll('[data-subtotal]').forEach(function (el) {
      addSubtotalLabels(el);
      var cur = el.textContent;
      if (mode === 'net') {
        if (el.__kkShown === cur) return;
        if (!RX1.test(cur)) return;
        var g = cents(cur.match(/\d{1,3}(?:[.  ]\d{3})*,\d{2}/)[0]);
        if (cartTotal !== g && cartFetchedFor !== g) { loadCart(g); return; }
        if (cartLoading || cartTotal == null) return;
        var net = cartTotal > 0 ? Math.round(g * cartNet / cartTotal) : 0;
        el.__kkOrig = el.innerHTML;
        el.textContent = fmt(net) + ' €';
        el.__kkShown = el.textContent;
      } else if (el.__kkShown != null) {
        if (el.__kkShown === cur) el.innerHTML = el.__kkOrig;
        el.__kkShown = null;
      }
    });
  }

  function addSubtotalLabels(el) {
    var row = el.parentElement;
    if (!row || row.__kkLabeled) return;
    row.__kkLabeled = true;
    var label = el.previousElementSibling;
    if (label) {
      var s = document.createElement('span');
      s.className = 'kk-net-only';
      s.textContent = ' (alv 0 %)';
      label.appendChild(s);
    }
    var note = document.createElement('div');
    note.className = 'kk-alv-cartnote kk-net-only';
    note.textContent = 'Hinnat ilman arvonlisäveroa. Arvonlisävero lisätään kassalla.';
    row.parentNode.insertBefore(note, row.nextSibling);
  }

  function markPrices() {
    document.querySelectorAll('.grid-product__price, [data-product-price]').forEach(function (el) {
      var has = RX1.test(el.textContent);
      if (has !== el.classList.contains('kk-has-money')) el.classList.toggle('kk-has-money', has);
    });
  }

  function setMainProductRate() {
    var mp = cfg.mainProduct;
    if (!mp) return;
    document.querySelectorAll('[data-section-type="product"][data-product-id="' + mp.id + '"]').forEach(function (s) {
      if (!s.hasAttribute('data-kk-vat')) s.setAttribute('data-kk-vat', String(mp.vat));
    });
  }

  function addProductNotes() {
    document.querySelectorAll('.product-block--price').forEach(function (block) {
      if (block.querySelector('.kk-alv-note')) return;
      var c = block.closest('[data-kk-vat]');
      var r = c ? parseFloat(c.getAttribute('data-kk-vat')) : STD;
      if (isNaN(r)) r = STD;
      var note = document.createElement('div');
      note.className = 'kk-alv-note';
      note.innerHTML =
        '<span class="kk-net-only">Hinta ilman arvonlisäveroa. Alv ' + rateText(r) + ' % lisätään kassalla. </span>' +
        '<button type="button" class="kk-alv-inline">' +
        '<span class="kk-gross-only">Näytä hinta ilman alv:tä</span>' +
        '<span class="kk-net-only">Näytä hinta alv:n kanssa</span>' +
        '</button>';
      note.querySelector('button').addEventListener('click', toggleMode);
      block.appendChild(note);
    });
  }

  function addSwitches() {
    document.querySelectorAll('.site-nav__icons').forEach(function (nav) {
      if (nav.querySelector('.kk-alv-switch')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kk-alv-switch';
      b.setAttribute('aria-label', 'Näytä hinnat ilman arvonlisäveroa');
      b.setAttribute('title', 'Vaihda hintojen näyttö: arvonlisäverollinen / alv 0 %');
      b.innerHTML = '<span class="kk-s kk-s-gross">Sis. alv</span><span class="kk-s kk-s-net">Alv 0 %</span>';
      b.addEventListener('click', toggleMode);
      nav.insertBefore(b, nav.firstChild);
    });
    document.querySelectorAll('.kk-alv-switch').forEach(function (b) {
      var p = mode === 'net' ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== p) b.setAttribute('aria-pressed', p);
    });
  }

  // Yrityssivuilla kauppaan vievat linkit saavat ?alv=0, jolloin hinnat aukeavat ilman alv:tä.
  function tagB2BLinks() {
    if (!cfg.b2bLinks) return;
    var main = document.getElementById('MainContent') || document;
    main.querySelectorAll('a[href*="/products/"], a[href*="/collections/"]').forEach(function (a) {
      if (a.__kkB2b) return;
      a.__kkB2b = true;
      var href = a.getAttribute('href');
      if (!href || /[?&]alv=/.test(href)) return;
      try {
        var u = new URL(href, location.href);
        if (u.origin !== location.origin) return;
        u.searchParams.set('alv', '0');
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    });
  }

  function run() {
    tagB2BLinks();
    setMainProductRate();
    addSwitches();
    addProductNotes();
    document.querySelectorAll(PRICE_SEL).forEach(processEl);
    processSubtotals();
    markPrices();
    if (!root.classList.contains('kk-ready')) root.classList.add('kk-ready');
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; run(); });
  }

  function setMode(m) {
    mode = m === 'net' ? 'net' : 'gross';
    try { localStorage.setItem(KEY, mode); } catch (e) {}
    root.classList.toggle('kk-net', mode === 'net');
    run();
  }
  function toggleMode() { setMode(mode === 'net' ? 'gross' : 'net'); }

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) setMode(e.newValue);
  });

  function init() {
    root.classList.toggle('kk-net', mode === 'net');
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.kkAlv = window.kkAlv || {};
  window.kkAlv.setMode = setMode;
  window.kkAlv.getMode = function () { return mode; };
  window.kkAlv._test = { toNetText: toNetText, fmt: fmt, cents: cents };
})();